import { SET_AUTHENTICATED, SET_UNAUTHENTICATED, RESET_REDUX, SET_LOGOUT_IN_PROGRESS } from "./actionTypes";

export const resetRedux = () => ({
  type: RESET_REDUX,
});

export const setAuthenticated = () =>({
  type: SET_AUTHENTICATED,
});

export const setUnauthenticated = () =>({
  type: SET_UNAUTHENTICATED,
});

export const setLogoutInProgress = () => ({
  type: SET_LOGOUT_IN_PROGRESS,
})

export function authenticated(dispatch:any) {
  dispatch(setAuthenticated())
}

export function unauthenticated(dispatch:any) {
  dispatch(setUnauthenticated())
}

export function setLogoutStart(dispatch:any) {
  dispatch(setLogoutInProgress())
}

export function reduxReset(dispatch:any) {
  dispatch(resetRedux());
}
